export default __webpack_public_path__ + "static/media/post_santa.7bb7b0c7.jpg";